// src/pages/onboarding/CompletionStep.jsx
import React from "react";
import { Box, Typography, Button, Stack, Alert } from "@mui/material";
import CelebrationRoundedIcon from "@mui/icons-material/CelebrationRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

export default function CompletionStep({ onComplete, saving = false, error = "" }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          bgcolor: "success.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 3,
        }}
      >
        <CelebrationRoundedIcon sx={{ fontSize: 50, color: "white" }} />
      </Box>

      <Typography variant="h4" fontWeight={800} gutterBottom>
        You're all set!
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 2, maxWidth: 500, mx: "auto" }}
      >
        Your AgentBlayna workspace is ready. Here's what you can do next:
      </Typography>

      <Stack
        spacing={2}
        sx={{
          mb: 4,
          maxWidth: 400,
          mx: "auto",
          textAlign: "left",
          bgcolor: "background.paper",
          p: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>
            1. Import your clients
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Upload your existing contact list to get started quickly.
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>
            2. Set up your first listing
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Add active listings to track them in one place.
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>
            3. Let AgentBlayna work for you
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Get AI-powered insights, follow-up reminders, and more.
          </Typography>
        </Box>
      </Stack>

      {error && (
        <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
          {error}
        </Alert>
      )}

      <Button
        variant="contained"
        size="large"
        onClick={onComplete}
        disabled={saving}
        endIcon={<ArrowForwardRoundedIcon />}
        sx={{
          px: 6,
          py: 1.5,
          borderRadius: 2,
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        {saving ? "Setting things up..." : "Go to Dashboard"}
      </Button>
    </Box>
  );
}
